<div *ngIf="createForm">

  <div class="container-fluid" [hidden]="indexPage < 1 || indexPage > 7">
    <div class="row">

      <div class="col-md-11">
        <!-- <div class="sticky-top fixedtop" id="step{{ indexPage }}">
          <app-form-errors [stepid]="'_STEP_ID_' + indexPage" [linkForRouter]="linkForRouter"></app-form-errors>
        </div> -->
        <div class="sticky-top fixedtop" *ngFor="let page of pages; let i = index">
          <div id="step{{ i+1 }}" *ngIf="indexPage === (i+1) && getIsCheckValid(indexPage)">
            <app-form-errors
              [stepid]="'_STEP_ID_' + (i+1)"
              [linkForRouter]="linkForRouter"
            >
            </app-form-errors>
          </div>
        </div>

        <div [class]="formClass">
          <fieldset>
            <legend *ngIf="indexPage > 0 && indexPage < 7">{{ getIntitule(indexPage) | translate }}</legend>

            <!-- Bloc 1. Identification de l'organisme qui passe le marché -->
            <app-step1 [uid]="getUid(1)" *ngIf="indexPage === 1" [parentForm]="form" [disabled]="disabled" [initial]="ann.divers?.initial"
               [linkForRouter]="linkForRouter">
            </app-step1>
            <app-step1common *ngIf="indexPage === 1" [uid]="getUidCommon(1)" [parentForm]="form" [disabled]="disabled" [divers]="ann.divers"
               [linkForRouter]="linkForRouter" [formName]="formName">
            </app-step1common>

            <!-- Bloc 2. Description du marché -->
            <app-step2 [uid]="getUid(2)" *ngIf="indexPage === 2" [parentForm]="form" [disabled]="disabled" [initial]="ann.divers?.initial"
             [linkForRouter]="linkForRouter">
            </app-step2>

            <!-- Bloc 3. Caractéristiques principales -->
            <app-step3 [uid]="getUid(3)" *ngIf="indexPage === 3" [parentForm]="form" [disabled]="disabled" [initial]="ann.divers?.initial"
             [linkForRouter]="linkForRouter">
            </app-step3>

            <!-- Bloc 4. Renseignements relatifs aux lots -->
            <app-step4 [uid]="getUid(4)" *ngIf="indexPage === 4" [parentForm]="form" [disabled]="disabled" [initial]="ann.divers?.initial"
             [linkForRouter]="linkForRouter">
            </app-step4>

            <!-- Bloc 5. Procédure et conditions de délai -->
            <app-step5 [uid]="getUid(5)" *ngIf="indexPage === 5" [parentForm]="form" [disabled]="disabled" [initial]="ann.divers?.initial"
             [linkForRouter]="linkForRouter">
            </app-step5>

            <!-- Bloc 6. Renseignements complémentaires  -->
            <app-step6 [uid]="getUid(6)" *ngIf="indexPage === 6" [parentForm]="form" [disabled]="disabled" [initial]="ann.divers?.initial"
             [linkForRouter]="linkForRouter">
            </app-step6>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</div>
